import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute,} from "@angular/router";

@Component({
  selector: 'app-password-success',
  templateUrl: './password-success.component.html',
  styleUrls: ['./password-success.component.css']
})
export class PasswordSuccessComponent implements OnInit {

  constructor(private router:Router) {

    var nu_first_name = localStorage.getItem('nu_first_name');
    if(nu_first_name !== null){
      this.router.navigate(['/subscriptions']);
    }
  }

  ngOnInit(): void {
    document.body.classList.add('bluebaground');
  }
  ngOnDestroy(): void {
    document.body.classList.remove('bluebaground');
  }

}
